import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'react-icons-kit';
import Tooltip from '@ls/react-tooltip';
import { ic_check_box } from 'react-icons-kit/md/ic_check_box';
import { ic_check_box_outline_blank } from 'react-icons-kit/md/ic_check_box_outline_blank';
import styled from 'styled-components';

const Root = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
`;
export const IconHolder = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${({disabled}) => disabled ? `grey` : `#1A3B73`};
`;

export const Label = styled.div`
    margin: 0 0 0 10px;
    color: ${({disabled}) => disabled ? `grey` : `default`};
`;

const Checkbox = (props) => {
  const { value, label, onChange, tooltip, tooltipProps, disabled, className } = props;
  if (props.checked !== undefined) {
    console.error('Use value instead of checked for prop');
  }
  const onClick = React.useCallback(() => onChange(!value), [onChange, value]);
  const checkbox = (
    <Root
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={className}
    >
      <IconHolder disabled={disabled}>
        {value ? <Icon icon={ic_check_box} size={24} /> : <Icon icon={ic_check_box_outline_blank} size={24} />}
      </IconHolder>
      <Label disabled={disabled}>
        {label}
      </Label>
    </Root>
  );

  if (tooltip) {
    return (
      <Tooltip
        render={tooltip}
        placement="bottom"
        delay={500}
        {...tooltipProps}
      >
        {checkbox}
      </Tooltip>

    );
  } else {
    return checkbox;
  }
};

Checkbox.propTypes = {
  value: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  tooltip: PropTypes.node,
  tooltipProps: PropTypes.object,
};

export default Checkbox;
